export { default as PersistentCartProductList } from './persistentCartProductList'



// WEBPACK FOOTER //
// ./src/modules/persistent-cart/persistentCartProductList/index.js